import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as actionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

// plan type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});
// rebate summary invoiced dispatch
export const dispatchRebateInvoiced = (data) => ({
  type: actionTypes.GET_REBATE_SUMMARY_INVOICED,
  payload: data,
});
// rebate summary dispute dispatch
export const dispatchRebateDispute = (data) => ({
  type: actionTypes.GET_REBATE_SUMMARY_DISPUTE,
  payload: data,
});
// rebate summary payment dispatch
export const dispatchRebatePayment = (data) => ({
  type: actionTypes.GET_REBATE_SUMMARY_PAYMENT_RECEIVED,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgRebateSummary = (data) => ({
  type: actionTypes.GET_ERROR_MSG_REBATE_SUMMARY,
  payload: data,
});
// error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgRebateSummary([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgRebateSummary([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
// rebate programe dispatch function
export const dispatchRebateProgram = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM,
  payload: data,
});
// on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME,
  payload: data,
});
// To get plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};

//  get rebate program funnction
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
export const setRbtSummTblRec = (payload) => ({
  type: actionTypes.SET_RBT_SUMM_TBL_DATA,
  payload,
});
// get rebatesummary invoiced
export const getRebateSummaryInvoiced = (value) => (dispatch) => {
  dispatch(dispatchRebateInvoiced([]));
  return axios
    .post(serviceEndPoint.REBATE_SUMMARY_INVOICED, value)
    .then((response) => {
      if (response.data.rebateDataGridReportVO.length > 0) {
        dispatch(dispatchRebateInvoiced(response.data));
      } else {
        dispatch(showNoDataMessage());
      }
      return response.data;
    })
    .catch((response) => {
      dispatch(dispatchRebateInvoiced([]));
    });
};
// get rebatesummary dispute
export const getRebateSummaryDispute = (value) => (dispatch) => {
  dispatch(dispatchRebateDispute([]));
  return axios
    .post(serviceEndPoint.REBATE_SUMMARY_DISPUTE, value)
    .then((response) => {
      if (response.data.rebateDisputeGridReportVO.length > 0) {
        dispatch(dispatchRebateDispute(response.data));
      } else {
        dispatch(showNoDataMessage());
      }
      return response.data;
    })
    .catch((response) => {
      dispatch(dispatchRebateDispute([]));
    });
};
// get rebatesummary paymentReceived
export const getRebateSummaryPayment = (value) => (dispatch) => {
  dispatch(dispatchRebatePayment([]));
  return axios
    .post(serviceEndPoint.REBATE_SUMMARY_PAYMENT_RECEIVED, value)
    .then((response) => {
      if (response.data.data.length > 0) {
        dispatch(dispatchRebatePayment(response.data));
      } else {
        dispatch(showNoDataMessage());
      }
      return response.data;
    })
    .catch((response) => {
      dispatch(dispatchRebatePayment([]));
    });
};
// dispatch DRAMS
export const dispatchDRAMS = (data) => ({
  type: actionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE,
  payload: data,
});

// dispatch state fiscal
export const dispatchStateFiscal = (data) => ({
  type: actionTypes.DISPLAY_STATE_FISCAL,
  payload: data,
});
// get DRAMS
export const getDramsInvStartQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRAMS_INVOICE_START_QUARTER, value)
    .then((response) => {
      return dispatch(dispatchDRAMS(response.data));
    })
    .catch((response) => {
      dispatch(dispatchDRAMS([]));
    });
};

// get state fiscal year
export const getStateFiscalYear = (value) => {
  return axios
    .post(serviceEndPoint.GET_STATE_FISCAL_YEAR, value)
    .then((response) => response.data?.statefiscalQtrVO?.stateFiscal)
    .catch(() => 1);
};
// refresh data
export const refreshRebateSummary = () => ({
  type: actionTypes.SET_REFRESH_DATA_REBATE,
  payload: {},
});
export const setSearchScreenObjData = (data) => ({
  type: actionTypes.SET_SEARCH_SCREEN_OBJ_DATA_RBT_SUMM,
  searchScreenObj: data,
});
